
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { MultiSelect, GroupedSelect, Select, orderOptions } from "../Components/Select.js";
import { tryHead, sortBy, contains, filter, choose, reduce, isEmpty, singleton, empty, toArray, ofArray, tryFind, map } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { comparePrimitives, safeHash, stringHash, compare, int32ToString, createObj, equals } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { reactApi, reactElement } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { concat, printf, toText, join } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { ConsumableByCommissionnumberRow, Msg } from "./Types.js";
import { bind, flatten, value as value_36, map as map_1, defaultArg, unwrap } from "../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { Helper_quantityAsStringWithComma } from "../Shared/Tool.js";
import { Helper_unitToHumanString } from "../Shared/Consumable.js";
import { Table } from "../Widgets/Table/Table.js";
import { OnTableRowClick$1, ColumnDefinition$1, CellContent } from "../Widgets/Table/Types.js";
import { empty as empty_1, toArray as toArray_1, singleton as singleton_1, append, delay, toList } from "../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { defaultOf } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { Button } from "../Components/Button.js";
import { InfiniteTable } from "../Widgets/Table/InfiniteTable.js";
import { RouterModule_nav, RouterModule_encodeQueryString, RouterModule_encodeParts } from "../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { unwrapConsumableId, unwrapToolId } from "../Shared/Helper.js";
import { resolve, name as name_16, useDefinitions } from "../InventoryStates/Display.js";
import { ofSeq, FSharpMap__TryFind } from "../fable_modules/fable-library-js.5.0.0-rc.2/Map.js";
import { parse } from "../fable_modules/fable-library-js.5.0.0-rc.2/Guid.js";
import { FormState__getValidation, ProblemReportId__get_unwrap, SetId__get_unwrap, ToolId__get_unwrap, PropertyConfigurationId } from "../Shared/Shared.js";
import { map as map_2 } from "../fable_modules/fable-library-js.5.0.0-rc.2/Array.js";
import { inventoryTableConfiguration } from "./Common.js";
import { ofToolState } from "../Shared/InventoryStateMapping.js";
import { priceToString } from "../Common.js";
import { Table_customPropertyValueDtoColumnDefinitions } from "../Widgets/CustomProperties.js";
import { InventoryKind } from "../Shared/InventoryStates.js";
import { List_groupBy, List_distinctBy } from "../fable_modules/fable-library-js.5.0.0-rc.2/Seq2.js";
import { Skeleton } from "../Components/Skeleton.js";
import { PrinzingBaustromReport } from "./CustomerReports/PrinzingBaustrom.js";
import { SwissAthleticReport } from "./CustomerReports/SwissAthletic.js";
import { ReportView } from "./Reports/InMaintenanceReportView.js";
import { Report } from "./CustomerReports/PrinzingHebebuehnenEislingenLager.js";
import { ReportView as ReportView_1 } from "./Reports/ReleaseDateReportView.js";
import { ReportView as ReportView_2 } from "./Reports/SwitchStorageReportView.js";
import { ReportView as ReportView_3 } from "./Reports/ConsumableAssignmentReportView.js";
import { ReportView as ReportView_4 } from "./Reports/ConsumableOutputSummedReportView.js";
import { ReportView as ReportView_5 } from "./Reports/ConsumableOutputSummedByReceiverReportView.js";
import { ReportView as ReportView_6 } from "./Reports/AssignmentProcedureInputsReportView.js";
import { ReportView as ReportView_7 } from "./CustomerReports/PrinzingInactiveToolsReportView.js";
import { ReportView as ReportView_8 } from "./Reports/DuplicateCheckReportView.js";
import { ReportView as ReportView_9 } from "./Reports/UninspectedToolsReportView.js";
import { ReportView as ReportView_10 } from "./Reports/InspectionStatisticsReportView.js";
import { ReportView as ReportView_11 } from "./Reports/InspectionCalendarReportView.js";
import { InformationAlert } from "../Components/Alert.js";
import { DuplicateCheckType, ReportType, Helper_reportById, Helper_hasReportDaterangeOption, Helper_categoryOrder, Helper_categoryI18NLabel, Helper_reports } from "../Shared/Report.js";
import { TextValue } from "../Components/Text.js";
import { DatePicker } from "../Components/DatePicker.js";
import { Storage__get_DisplayName } from "../Shared/Storage.js";
import { Checkbox } from "../Components/Checkbox.js";
import { React_useElmish_Z6C327F2E } from "../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { initWithQueryParameter, update as update_1, init as init_1 } from "./State.js";
import { SectionContainer } from "../Widgets/Container.js";

function CommissionnumberSelect(props) {
    let elems;
    const patternInput = useTranslation();
    const options_1 = orderOptions(map((r) => ({
        label: r.CommissionNumber,
        value: r,
    }), props.Reports));
    const selectedElement = tryFind((o) => {
        const matchValue = props.State.SelectedConsumableByCommissionnumber;
        if (matchValue == null) {
            return false;
        }
        else {
            return equals(matchValue, o.value);
        }
    }, options_1);
    return reactElement("div", createObj(ofArray([["className", join(" ", ["select-with-label", "form-group", "flex-grow-1"])], (elems = [createElement(Select, {
        ComponentState: "enabled",
        IsClearable: false,
        Label: patternInput[0]("report.choose_commission_number"),
        NoOptionsMessage: "report.commission_report_not_found",
        OnChange: (selected) => {
            if (selected == null) {
            }
            else {
                props.Dispatch(new Msg(5, [selected.value]));
            }
        },
        Options: options_1,
        PlaceholderKey: "report.commission_report_placeholder",
        TestId: "report-commission-number-select",
        Value: unwrap(selectedElement),
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function toConsumableByCommissionnumberRow(consumableResult) {
    let arg_1;
    const quantity = Helper_quantityAsStringWithComma(consumableResult.Quantity);
    return new ConsumableByCommissionnumberRow(consumableResult.Id, consumableResult.Name, (arg_1 = Helper_unitToHumanString(consumableResult.Unit), toText(printf("%s %s"))(quantity)(arg_1)));
}

function ConsumablesOverview(props) {
    let elems, TableRows;
    const t = useTranslation()[0];
    const children = singleton(reactElement("div", createObj(ofArray([["id", "tools-table"], ["className", join(" ", ["bg-white", "flex", "flex-col"])], (elems = [createElement(Table, (TableRows = toArray(map(toConsumableByCommissionnumberRow, props.ConsumableResults)), {
        ColumnDefinitions: [new ColumnDefinition$1("name", "", t("general.name"), (row) => (new CellContent(0, [row.Name])), "text", "text"), new ColumnDefinition$1("quantity", "", t("general.quantity"), (row_1) => (new CellContent(0, [row_1.Quantity])), "text", "text")],
        Controls: empty(),
        Options: {
            BorderStyle: "full",
            CSVDownload: true,
            ConfigurableColumns: false,
            CustomTableFilters: false,
            DefaultSortColumn: ["name", "asc"],
            Fullscreen: false,
            GlobalSearch: true,
            RowSelection: "disabled",
            SaveTableConfiguration: false,
        },
        TableKey: "not-defined-table",
        TableRows: TableRows,
    }))], ["children", reactApi.Children.toArray(Array.from(elems))])]))));
    return reactElement("div", {
        children: reactApi.Children.toArray(Array.from(children)),
    });
}

function ConsumableByCommissionnumberView(props) {
    let elems_4;
    const patternInput = useTranslation();
    return reactElement("div", createObj(ofArray([["className", "flex-grow-1 d-flex flex-column"], (elems_4 = toList(delay(() => {
        let elems;
        return append(singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["d-flex", "flex-row", "mx-2", "mb-2"])], (elems = [createElement(CommissionnumberSelect, {
            Dispatch: props.Dispatch,
            Reports: props.Reports,
            State: props.State,
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
            let children, elems_1, Label;
            const matchValue = props.State.SelectedConsumableByCommissionnumber;
            if (matchValue == null) {
                return singleton_1(defaultOf());
            }
            else {
                const selectedConsumableByCommissionnumber = matchValue;
                return append(singleton_1((children = singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["d-flex", "ml-auto"])], (elems_1 = [createElement(Button, (Label = patternInput[0]("report.print_report"), {
                    ComponentState: (props.State.SelectedConsumableByCommissionnumber != null) ? (props.State.CsvDownloadActive ? "disabled" : "enabled") : "disabled",
                    Label: Label,
                    OnClick: () => {
                        props.Dispatch(new Msg(13, []));
                    },
                    TestId: "report-consumablebycomissionnumber-print-button",
                    Variant: "primary",
                }))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), reactElement("div", {
                    children: reactApi.Children.toArray(Array.from(children)),
                }))), delay(() => {
                    let elems_3, elems_2;
                    return singleton_1(reactElement("div", createObj(ofArray([["className", "d-flex flex-row"], (elems_3 = [reactElement("div", createObj(ofArray([["className", "flex-grow-1"], (elems_2 = [createElement(ConsumablesOverview, {
                        ConsumableResults: selectedConsumableByCommissionnumber.Consumables,
                    })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])]))));
                }));
            }
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_4))])])));
}

function ProblemPerToolOverview(props) {
    let elems, TableRows;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["id", "problem-per-tool-overview-table"], ["className", join(" ", ["h-full"])], (elems = [createElement(InfiniteTable, (TableRows = toArray(props.ProblemReportsPerTool), {
        ColumnDefinitions: [new ColumnDefinition$1("manufacturer", "", t("tool.manufacturer"), (row) => (new CellContent(0, [row.Tool.Manufacturer])), "text", "text"), new ColumnDefinition$1("model", "", t("tool.model"), (row_1) => (new CellContent(0, [row_1.Tool.Model])), "text", "text"), new ColumnDefinition$1("displayName", "", t("tool.displayname"), (row_2) => (new CellContent(0, [row_2.Tool.DisplayName])), "text", "text"), new ColumnDefinition$1("serialNumber", "", t("tool.serial_number"), (row_3) => (new CellContent(0, [row_3.Tool.SerialNumber])), "text", "text"), new ColumnDefinition$1("inventoryNumber", "", t("general.inventory_number"), (row_4) => (new CellContent(0, [row_4.Tool.InventoryNumber])), "text", "text"), new ColumnDefinition$1("qRCodeIds", "", t("general.qr_code"), (row_5) => (new CellContent(0, [isEmpty(row_5.Tool.QRCodeIds) ? "" : reduce((list_2, code) => concat(list_2, ", ", ...code), row_5.Tool.QRCodeIds)])), "text", "text"), new ColumnDefinition$1("sumOfProblemReports", "", t("report.problem_report_sum"), (row_6) => (new CellContent(0, [int32ToString(row_6.SumOfProblemReports)])), "text", "text"), new ColumnDefinition$1("lastProblemReport", "", t("report.last_problem_report"), (row_7) => (new CellContent(8, [row_7.LastProblemReport])), "dateRange", "date")],
        Controls: empty(),
        Options: {
            BorderStyle: "full",
            CSVDownload: true,
            ConfigurableColumns: false,
            CustomTableFilters: false,
            DefaultSortColumn: ["manufacturer", "asc"],
            Fullscreen: false,
            GlobalSearch: true,
            OnRowClick: new OnTableRowClick$1(1, [(row_8) => RouterModule_encodeParts(ofArray(["tools", unwrapToolId(row_8.Tool.Id)]), 1)]),
            RowSelection: "disabled",
            SaveTableConfiguration: false,
            WithQueryParameters: false,
        },
        TableKey: "not-defined-table",
        TableRows: TableRows,
    }))], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function ProblemReportsPerToolView(props) {
    return createElement(ProblemPerToolOverview, {
        Dispatch: props.Dispatch,
        ProblemReportsPerTool: props.Reports,
    });
}

function AppointmentsView(props) {
    let elems, TableRows;
    const t = useTranslation()[0];
    const definitions = useDefinitions();
    return reactElement("div", createObj(ofArray([["id", "appointment-per-tool-table"], ["className", join(" ", ["h-full"])], (elems = [createElement(InfiniteTable, (TableRows = toArray(props.Reports), {
        ColumnDefinitions: toArray_1(delay(() => append(singleton_1(new ColumnDefinition$1("date", "", t("general.date"), (row) => (new CellContent(8, [row.ReminderDate])), "dateRange", "date")), delay(() => append((props.State.Customer.tag === 6) ? choose((propertyConfiguration) => {
            const matchValue_1 = propertyConfiguration.Type;
            switch (matchValue_1.tag) {
                case 0:
                    return new ColumnDefinition$1(propertyConfiguration.Name, "", propertyConfiguration.Name, (dto) => (new CellContent(0, [defaultArg(map_1((property) => property.Value, FSharpMap__TryFind(ofSeq(map((customProperty) => [new PropertyConfigurationId(parse(customProperty.Id)), customProperty], dto.Inventory.CustomProperties), {
                        Compare: (x, y) => (compare(x, y) | 0),
                    }), propertyConfiguration.Id)), "")])), "text", "text");
                default:
                    return undefined;
            }
        }, filter((row_1) => (row_1.Name.trim() === "Verantwortlich"), props.PropertyConfigurations)) : (empty_1()), delay(() => append(singleton_1(new ColumnDefinition$1("title", "", t("general.designation"), (row_2) => (new CellContent(0, [row_2.Title])), "text", "text")), delay(() => append(singleton_1(new ColumnDefinition$1("description", "", t("general.description"), (row_3) => (new CellContent(0, [row_3.Description])), "text", "text")), delay(() => append(map_2((columnDefinition) => (new ColumnDefinition$1(columnDefinition.Id, columnDefinition.Group, columnDefinition.Header, (row_4) => columnDefinition.AccessorFunction(row_4.Inventory), columnDefinition.Filter, columnDefinition.ColumnType)), inventoryTableConfiguration(t, definitions, props.PropertyConfigurations, props.State.Customer, props.Configuration)), delay(() => singleton_1(new ColumnDefinition$1("isConfirmed", "", t("general.done"), (row_5) => (new CellContent(0, [row_5.IsConfirmed ? t("general.yes") : t("general.no")])), "text", "text")))))))))))))),
        Controls: empty(),
        Options: {
            BorderStyle: "full",
            CSVDownload: true,
            ConfigurableColumns: true,
            CustomTableFilters: false,
            DefaultSortColumn: ["date", "asc"],
            Fullscreen: false,
            GlobalSearch: true,
            OnRowClick: new OnTableRowClick$1(1, [(tool) => {
                const matchValue_3 = tool.IdType;
                return (matchValue_3.tag === 0) ? RouterModule_encodeParts(ofArray(["tools", ToolId__get_unwrap(matchValue_3.fields[0])]), 1) : ((matchValue_3.tag === 1) ? RouterModule_encodeParts(ofArray(["toolswithquantity", ToolId__get_unwrap(matchValue_3.fields[0])]), 1) : ((matchValue_3.tag === 2) ? RouterModule_encodeParts(ofArray(["sets", SetId__get_unwrap(matchValue_3.fields[0])]), 1) : RouterModule_encodeParts(ofArray(["consumables", unwrapConsumableId(matchValue_3.fields[0])]), 1)));
            }]),
            RowSelection: "disabled",
            SaveTableConfiguration: true,
            WithQueryParameters: false,
        },
        TableKey: "report-appointments",
        TableRows: TableRows,
    }))], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function OpenAppointmentsView(props) {
    let elems, TableRows;
    const t = useTranslation()[0];
    const definitions = useDefinitions();
    return reactElement("div", createObj(ofArray([["id", "open-appointment-table"], ["className", join(" ", ["h-full"])], (elems = [createElement(InfiniteTable, (TableRows = toArray(props.Reports), {
        ColumnDefinitions: toArray_1(delay(() => append(singleton_1(new ColumnDefinition$1("date", "", t("general.date"), (row) => (new CellContent(8, [row.ReminderDate])), "dateRange", "date")), delay(() => append((props.State.Customer.tag === 6) ? choose((propertyConfiguration) => {
            const matchValue_1 = propertyConfiguration.Type;
            switch (matchValue_1.tag) {
                case 0:
                    return new ColumnDefinition$1(propertyConfiguration.Name, "", propertyConfiguration.Name, (dto) => (new CellContent(0, [defaultArg(map_1((property) => property.Value, FSharpMap__TryFind(ofSeq(map((customProperty) => [new PropertyConfigurationId(parse(customProperty.Id)), customProperty], dto.Inventory.CustomProperties), {
                        Compare: (x, y) => (compare(x, y) | 0),
                    }), propertyConfiguration.Id)), "")])), "text", "text");
                default:
                    return undefined;
            }
        }, filter((row_1) => (row_1.Name.trim() === "Verantwortlich"), props.PropertyConfigurations)) : (empty_1()), delay(() => append(singleton_1(new ColumnDefinition$1("title", "", t("general.designation"), (row_2) => (new CellContent(0, [row_2.Title])), "text", "text")), delay(() => append(singleton_1(new ColumnDefinition$1("description", "", t("general.description"), (row_3) => (new CellContent(0, [row_3.Description])), "text", "text")), delay(() => map_2((columnDefinition) => (new ColumnDefinition$1(columnDefinition.Id, columnDefinition.Group, columnDefinition.Header, (row_4) => columnDefinition.AccessorFunction(row_4.Inventory), columnDefinition.Filter, columnDefinition.ColumnType)), inventoryTableConfiguration(t, definitions, props.PropertyConfigurations, props.State.Customer, props.Configuration)))))))))))),
        Controls: empty(),
        Options: {
            BorderStyle: "full",
            CSVDownload: true,
            ConfigurableColumns: true,
            CustomTableFilters: false,
            DefaultSortColumn: ["date", "asc"],
            Fullscreen: false,
            GlobalSearch: true,
            OnRowClick: new OnTableRowClick$1(1, [(tool) => {
                const matchValue_2 = tool.IdType;
                return (matchValue_2.tag === 0) ? RouterModule_encodeParts(ofArray(["tools", ToolId__get_unwrap(matchValue_2.fields[0])]), 1) : ((matchValue_2.tag === 1) ? RouterModule_encodeParts(ofArray(["toolswithquantity", ToolId__get_unwrap(matchValue_2.fields[0])]), 1) : ((matchValue_2.tag === 2) ? RouterModule_encodeParts(ofArray(["sets", SetId__get_unwrap(matchValue_2.fields[0])]), 1) : RouterModule_encodeParts(ofArray(["consumables", unwrapConsumableId(matchValue_2.fields[0])]), 1)));
            }]),
            RowSelection: "disabled",
            SaveTableConfiguration: true,
            WithQueryParameters: false,
        },
        TableKey: "report-open-appointments",
        TableRows: TableRows,
    }))], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function MissedAppointmentsView(props) {
    let elems, TableRows;
    const t = useTranslation()[0];
    const definitions = useDefinitions();
    return reactElement("div", createObj(ofArray([["id", "appointments"], ["className", join(" ", ["h-full"])], (elems = [createElement(InfiniteTable, (TableRows = toArray(props.Reports), {
        ColumnDefinitions: toArray_1(delay(() => append(singleton_1(new ColumnDefinition$1("date", "", t("general.date"), (row) => (new CellContent(8, [row.ReminderDate])), "dateRange", "date")), delay(() => append((props.State.Customer.tag === 6) ? choose((propertyConfiguration) => {
            const matchValue_1 = propertyConfiguration.Type;
            switch (matchValue_1.tag) {
                case 0:
                    return new ColumnDefinition$1(propertyConfiguration.Name, "", propertyConfiguration.Name, (dto) => (new CellContent(0, [defaultArg(map_1((property) => property.Value, FSharpMap__TryFind(ofSeq(map((customProperty) => [new PropertyConfigurationId(parse(customProperty.Id)), customProperty], dto.Inventory.CustomProperties), {
                        Compare: (x, y) => (compare(x, y) | 0),
                    }), propertyConfiguration.Id)), "")])), "text", "text");
                default:
                    return undefined;
            }
        }, filter((row_1) => (row_1.Name.trim() === "Verantwortlich"), props.PropertyConfigurations)) : (empty_1()), delay(() => append(singleton_1(new ColumnDefinition$1("title", "", t("general.designation"), (row_2) => (new CellContent(0, [row_2.Title])), "text", "text")), delay(() => append(singleton_1(new ColumnDefinition$1("description", "", t("general.description"), (row_3) => (new CellContent(0, [row_3.Description])), "text", "text")), delay(() => map_2((columnDefinition) => (new ColumnDefinition$1(columnDefinition.Id, columnDefinition.Group, columnDefinition.Header, (row_4) => columnDefinition.AccessorFunction(row_4.Inventory), columnDefinition.Filter, columnDefinition.ColumnType)), inventoryTableConfiguration(t, definitions, props.PropertyConfigurations, props.State.Customer, props.Configuration)))))))))))),
        Controls: empty(),
        Options: {
            BorderStyle: "full",
            CSVDownload: true,
            ConfigurableColumns: true,
            CustomTableFilters: false,
            DefaultSortColumn: ["date", "asc"],
            Fullscreen: false,
            GlobalSearch: true,
            OnRowClick: new OnTableRowClick$1(1, [(tool) => {
                const matchValue_2 = tool.IdType;
                return (matchValue_2.tag === 0) ? RouterModule_encodeParts(ofArray(["tools", ToolId__get_unwrap(matchValue_2.fields[0])]), 1) : ((matchValue_2.tag === 1) ? RouterModule_encodeParts(ofArray(["toolswithquantity", ToolId__get_unwrap(matchValue_2.fields[0])]), 1) : ((matchValue_2.tag === 2) ? RouterModule_encodeParts(ofArray(["sets", SetId__get_unwrap(matchValue_2.fields[0])]), 1) : RouterModule_encodeParts(ofArray(["consumables", unwrapConsumableId(matchValue_2.fields[0])]), 1)));
            }]),
            RowSelection: "disabled",
            SaveTableConfiguration: true,
            WithQueryParameters: false,
        },
        TableKey: "report-missed-appointments",
        TableRows: TableRows,
    }))], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function ToolsRemovalsOrEntriesByDateRangeOverview(props) {
    let TableRows;
    const t = useTranslation()[0];
    const definitions = useDefinitions();
    return createElement(Table, (TableRows = toArray(props.Tools), {
        ColumnDefinitions: toArray_1(delay(() => append(singleton_1(new ColumnDefinition$1("date", "", t("general.date"), (row) => (new CellContent(8, [row.Date])), "dateRange", "date")), delay(() => append(props.WithEntryTypeColumn ? singleton_1(new ColumnDefinition$1("inventoryEntryType", "", t("general.event"), (row_1) => {
            let matchValue;
            return new CellContent(0, [(matchValue = row_1.InventoryEntryType, (matchValue === "retired") ? t("event.retired") : ((matchValue === "created") ? "" : t("event.lost")))]);
        }, "select", "text")) : empty_1(), delay(() => append(singleton_1(new ColumnDefinition$1("state", "", t("general.state"), (row_2) => (new CellContent(0, [name_16(t, resolve(definitions, row_2.StateKey, ofToolState(row_2.State)))])), "select", "text")), delay(() => append(singleton_1(new ColumnDefinition$1("manufacturer", "", t("tool.manufacturer"), (row_3) => (new CellContent(0, [row_3.Manufacturer])), "text", "text")), delay(() => append(singleton_1(new ColumnDefinition$1("model", "", t("tool.model"), (row_4) => (new CellContent(0, [row_4.Model])), "text", "text")), delay(() => append(singleton_1(new ColumnDefinition$1("displayName", "", t("tool.displayname"), (row_5) => (new CellContent(0, [row_5.DisplayName])), "text", "text")), delay(() => append(singleton_1(new ColumnDefinition$1("serialNumber", "", t("tool.serial_number"), (row_6) => (new CellContent(0, [row_6.SerialNumber])), "text", "text")), delay(() => append(singleton_1(new ColumnDefinition$1("inventoryNumber", "", t("general.inventory_number"), (row_7) => (new CellContent(0, [row_7.InventoryNumber])), "text", "text")), delay(() => append(singleton_1(new ColumnDefinition$1("storageName", "", t("general.storage"), (row_8) => (new CellContent(0, [row_8.StorageInformation.StorageName])), "select", "text")), delay(() => append(singleton_1(new ColumnDefinition$1("storageSpace", "", t("tool.storage_space"), (row_9) => (new CellContent(0, [row_9.StorageInformation.StorageSpace])), "text", "text")), delay(() => append(singleton_1(new ColumnDefinition$1("supplierArticleNumber", t("tool.commercial_data"), t("general.supplier_article_number"), (dto) => (new CellContent(0, [dto.CommercialData.SupplierArticleNumber])), "text", "text")), delay(() => append(singleton_1(new ColumnDefinition$1("supplier", t("tool.commercial_data"), t("general.supplier"), (dto_1) => (new CellContent(0, [dto_1.CommercialData.Supplier])), "text", "text")), delay(() => append(singleton_1(new ColumnDefinition$1("purchaseDate", t("tool.commercial_data"), t("general.purchase_date"), (dto_2) => (new CellContent(8, [dto_2.CommercialData.PurchaseDate])), "text", "date")), delay(() => append(singleton_1(new ColumnDefinition$1("guranteeDate", t("tool.commercial_data"), t("general.gurantee_date"), (dto_3) => (new CellContent(8, [dto_3.CommercialData.WarrantyDate])), "text", "date")), delay(() => append(singleton_1(new ColumnDefinition$1("purchasePrice", t("tool.commercial_data"), t("general.purchase_price"), (dto_4) => {
            const matchValue_1 = dto_4.CommercialData.PurchasePrice;
            return (matchValue_1 != null) ? (new CellContent(0, [priceToString(matchValue_1, props.Configuration.Currency)])) : (new CellContent(0, [""]));
        }, "text", "text")), delay(() => Table_customPropertyValueDtoColumnDefinitions(filter((propertyConfiguration) => {
            const matchValue_2 = propertyConfiguration.Visibility;
            switch (matchValue_2.tag) {
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 12:
                case 11:
                    return false;
                default:
                    return true;
            }
        }, props.PropertyConfigurations), t("tool.custom_properties"), (dto_5) => dto_5.CustomProperties, t))))))))))))))))))))))))))))))))),
        Controls: empty(),
        Options: {
            BorderStyle: "full",
            CSVDownload: true,
            ConfigurableColumns: false,
            CustomTableFilters: false,
            DefaultSortColumn: ["date", "asc"],
            Fullscreen: false,
            GlobalSearch: true,
            OnRowClick: new OnTableRowClick$1(1, [(tool) => RouterModule_encodeParts(ofArray(["tools", tool.ToolId]), 1)]),
            RowSelection: "disabled",
            SaveTableConfiguration: false,
        },
        TableKey: "not-defined-table",
        TableRows: TableRows,
    }));
}

function SchoeffmannRetiredToolsWithQRCodeId(props) {
    let elems_1, elems, TableRows;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["id", "tools-table"], (elems_1 = [reactElement("div", createObj(ofArray([["id", "tools-table"], ["className", join(" ", ["flex", "flex-col"])], (elems = [createElement(Table, (TableRows = toArray(props.Tools), {
        ColumnDefinitions: [new ColumnDefinition$1("manufacturer", "", t("tool.manufacturer"), (row) => (new CellContent(0, [row.Manufacturer])), "text", "text"), new ColumnDefinition$1("model", "", t("tool.model"), (row_1) => (new CellContent(0, [row_1.Model])), "text", "text"), new ColumnDefinition$1("displayName", "", t("tool.displayname"), (row_2) => (new CellContent(0, [row_2.DisplayName])), "text", "text"), new ColumnDefinition$1("serialNumber", "", t("tool.serial_number"), (row_3) => (new CellContent(0, [row_3.SerialNumber])), "text", "text"), new ColumnDefinition$1("storageName", "", t("general.storage"), (row_4) => (new CellContent(0, [row_4.StorageName])), "text", "text"), new ColumnDefinition$1("qrCodeId", "", t("general.qr_code"), (row_5) => (new CellContent(0, [row_5.QRCodeId])), "text", "text"), new ColumnDefinition$1("retiredDate", "", t("tool.retired_at"), (row_6) => (new CellContent(9, [row_6.RetiredDate])), "dateRange", "date")],
        Controls: empty(),
        Options: {
            BorderStyle: "full",
            CSVDownload: true,
            ConfigurableColumns: false,
            CustomTableFilters: false,
            DefaultSortColumn: ["manufacturer", "asc"],
            Fullscreen: false,
            GlobalSearch: true,
            OnRowClick: new OnTableRowClick$1(1, [(tool) => RouterModule_encodeParts(ofArray(["tools", unwrapToolId(tool.ToolId)]), 1)]),
            RowSelection: "disabled",
            SaveTableConfiguration: false,
        },
        TableKey: "not-defined-table",
        TableRows: TableRows,
    }))], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function SchoeffmannActiveAndInMaintenanceToolsWithQRCodeId(props) {
    let elems, TableRows;
    const t = useTranslation()[0];
    const definitions = useDefinitions();
    return reactElement("div", createObj(ofArray([["id", "tools-table"], ["className", join(" ", ["flex", "flex-col"])], (elems = [createElement(Table, (TableRows = toArray(props.Tools), {
        ColumnDefinitions: [new ColumnDefinition$1("manufacturer", "", t("tool.manufacturer"), (row) => (new CellContent(0, [row.Manufacturer])), "text", "text"), new ColumnDefinition$1("model", "", t("tool.model"), (row_1) => (new CellContent(0, [row_1.Model])), "text", "text"), new ColumnDefinition$1("displayName", "", t("tool.displayname"), (row_2) => (new CellContent(0, [row_2.DisplayName])), "text", "text"), new ColumnDefinition$1("serialNumber", "", t("tool.serial_number"), (row_3) => (new CellContent(0, [row_3.SerialNumber])), "text", "text"), new ColumnDefinition$1("storageName", "", t("general.storage"), (row_4) => (new CellContent(0, [row_4.StorageName])), "text", "text"), new ColumnDefinition$1("qrCodeId", "", t("general.qr_code"), (row_5) => (new CellContent(0, [row_5.QRCodeId])), "text", "text"), new ColumnDefinition$1("status", "", t("general.state"), (row_6) => (new CellContent(0, [name_16(t, resolve(definitions, row_6.StateKey, ofToolState(row_6.State)))])), "select", "text")],
        Controls: empty(),
        Options: {
            BorderStyle: "full",
            CSVDownload: true,
            ConfigurableColumns: false,
            CustomTableFilters: false,
            DefaultSortColumn: ["manufacturer", "asc"],
            Fullscreen: false,
            GlobalSearch: true,
            OnRowClick: new OnTableRowClick$1(1, [(tool) => RouterModule_encodeParts(ofArray(["tools", unwrapToolId(tool.ToolId)]), 1)]),
            RowSelection: "disabled",
            SaveTableConfiguration: false,
        },
        TableKey: "not-defined-table",
        TableRows: TableRows,
    }))], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function ReservationsByDaterangeReport(props) {
    let elems, TableRows;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["id", "tools-table"], (elems = [createElement(Table, (TableRows = toArray(props.Tools), {
        ColumnDefinitions: [new ColumnDefinition$1("manufacturer", "", t("tool.manufacturer"), (row) => (new CellContent(0, [row.Manufacturer])), "text", "text"), new ColumnDefinition$1("model", "", t("tool.model"), (row_1) => (new CellContent(0, [row_1.Model])), "text", "text"), new ColumnDefinition$1("displayName", "", t("tool.displayname"), (row_2) => (new CellContent(0, [row_2.DisplayName])), "text", "text"), new ColumnDefinition$1("serialNumber", "", t("tool.serial_number"), (row_3) => (new CellContent(0, [row_3.SerialNumber])), "text", "text"), new ColumnDefinition$1("reservationCreatedBy", "", t("general.sender"), (row_4) => (new CellContent(0, [row_4.ReservationCreatedBy])), "select", "text"), new ColumnDefinition$1("reservationForUser", "", t("tool.reserved_for"), (row_5) => (new CellContent(0, [row_5.ReservationForUser])), "select", "text"), new ColumnDefinition$1("startDate", "", t("general.start_date"), (row_6) => (new CellContent(9, [row_6.StartDate])), "dateRange", "date"), new ColumnDefinition$1("endDate", "", t("general.end_date"), (row_7) => (new CellContent(9, [row_7.EndDate])), "dateRange", "date")],
        Controls: empty(),
        Options: {
            BorderStyle: "full",
            CSVDownload: true,
            ConfigurableColumns: false,
            CustomTableFilters: false,
            DefaultSortColumn: ["manufacturer", "asc"],
            Fullscreen: false,
            GlobalSearch: true,
            OnRowClick: new OnTableRowClick$1(1, [(tool) => {
                const matchValue = tool.SetId;
                return (matchValue == null) ? RouterModule_encodeParts(ofArray(["tools", ToolId__get_unwrap(tool.ToolId)]), 1) : RouterModule_encodeParts(ofArray(["sets", SetId__get_unwrap(matchValue)]), 1);
            }]),
            RowSelection: "disabled",
            SaveTableConfiguration: false,
        },
        TableKey: "not-defined-table",
        TableRows: TableRows,
    }))], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function WithoutReservationsByDateRangeReport(props) {
    let elems, TableRows;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["id", "tools-table"], ["className", join(" ", ["flex", "flex-col"])], (elems = [createElement(Table, (TableRows = toArray(props.Tools), {
        ColumnDefinitions: [new ColumnDefinition$1("manufacturer", "", t("tool.manufacturer"), (row) => (new CellContent(0, [row.Manufacturer])), "text", "text"), new ColumnDefinition$1("model", "", t("tool.model"), (row_1) => (new CellContent(0, [row_1.Model])), "text", "text"), new ColumnDefinition$1("displayName", "", t("tool.displayname"), (row_2) => (new CellContent(0, [row_2.DisplayName])), "text", "text"), new ColumnDefinition$1("serialNumber", "", t("tool.serial_number"), (row_3) => (new CellContent(0, [row_3.SerialNumber])), "text", "text")],
        Controls: empty(),
        Options: {
            BorderStyle: "full",
            CSVDownload: true,
            ConfigurableColumns: false,
            CustomTableFilters: false,
            DefaultSortColumn: ["manufacturer", "asc"],
            Fullscreen: false,
            GlobalSearch: true,
            OnRowClick: new OnTableRowClick$1(1, [(tool) => RouterModule_encodeParts(ofArray(["tools", ToolId__get_unwrap(tool.ToolId)]), 1)]),
            RowSelection: "disabled",
            SaveTableConfiguration: false,
        },
        TableKey: "not-defined-table",
        TableRows: TableRows,
    }))], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function PrinzingReportAssignedToolsWithLastComment(props) {
    let elems_1, children, elems, TableRows;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["id", "tools-table"], ["className", join(" ", ["h-full"])], (elems_1 = [(children = singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["my-2"])], (elems = [createElement(Button, {
        ComponentState: props.State.CsvDownloadActive ? "disabled" : "enabled",
        Label: t("report.print_report"),
        OnClick: () => {
            props.Dispatch(new Msg(13, []));
        },
        TestId: "report-export-excel-assigned-to-button",
        Variant: "primary",
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), reactElement("div", {
        children: reactApi.Children.toArray(Array.from(children)),
    })), createElement(InfiniteTable, (TableRows = toArray(props.Tools), {
        ColumnDefinitions: toArray_1(delay(() => append(singleton_1(new ColumnDefinition$1("assignedUserName", "", t("dashboard.assigned_to"), (row) => (new CellContent(0, [row.AssignedUsername])), "text", "text")), delay(() => append(singleton_1(new ColumnDefinition$1("lastComment", "", t("general.commission"), (row_1) => (new CellContent(0, [row_1.LastComment])), "text", "text")), delay(() => append(singleton_1(new ColumnDefinition$1("manufacturer", "", t("tool.manufacturer"), (row_2) => (new CellContent(0, [row_2.Manufacturer])), "text", "text")), delay(() => append(singleton_1(new ColumnDefinition$1("model", "", t("tool.model"), (row_3) => (new CellContent(0, [row_3.Model])), "text", "text")), delay(() => append(singleton_1(new ColumnDefinition$1("serialNumber", "", t("tool.serial_number"), (row_4) => (new CellContent(0, [row_4.SerialNumber])), "text", "text")), delay(() => append(singleton_1(new ColumnDefinition$1("displayName", "", t("tool.displayname"), (row_5) => (new CellContent(0, [row_5.DisplayName])), "text", "text")), delay(() => append(singleton_1(new ColumnDefinition$1("checknumber", "", t("tool.prinzing.check_number"), (row_6) => (new CellContent(0, [row_6.Checknumber])), "text", "text")), delay(() => append(singleton_1(new ColumnDefinition$1("inventorynumber", "", t("tool.inventory_number"), (row_7) => (new CellContent(0, [row_7.InventoryNumber])), "text", "text")), delay(() => append(singleton_1(new ColumnDefinition$1("quantity", "", t("general.quantity"), (row_8) => (new CellContent(0, [row_8.Quantity])), "text", "text")), delay(() => append(singleton_1(new ColumnDefinition$1("toolType", "", t("general.tool_type"), (dto) => {
            let matchValue_1;
            return new CellContent(5, [(matchValue_1 = dto.IsSet, dto.IsToolWithQuantity ? (matchValue_1 ? (new InventoryKind(0, [])) : (new InventoryKind(2, []))) : (matchValue_1 ? (new InventoryKind(1, [])) : (new InventoryKind(0, []))))]);
        }, "select", "text")), delay(() => append(singleton_1(new ColumnDefinition$1("assignedDate", "", t("report.assigned_at"), (row_9) => (new CellContent(9, [row_9.AssignedDate])), "text", "date")), delay(() => append(singleton_1(new ColumnDefinition$1("lastInspectionDate", "", t("tool.last_check"), (dto_1) => (new CellContent(8, [dto_1.LastInspectionDate])), "dateRange", "date")), delay(() => append(singleton_1(new ColumnDefinition$1("nextInspectionDate", "", t("tool.next_inspection"), (dto_2) => (new CellContent(8, [dto_2.NextInspectionDate])), "dateRange", "date")), delay(() => append(singleton_1(new ColumnDefinition$1("purchasePrice", t("tool.commercial_data"), t("general.purchase_price"), (dto_3) => {
            const matchValue_3 = dto_3.PurchasePrice;
            return (matchValue_3 != null) ? (new CellContent(0, [priceToString(matchValue_3, props.Configuration.Currency)])) : (new CellContent(0, [""]));
        }, "text", "text")), delay(() => Table_customPropertyValueDtoColumnDefinitions(filter((propertyConfiguration) => {
            const matchValue_4 = propertyConfiguration.Visibility;
            switch (matchValue_4.tag) {
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 12:
                case 11:
                    return false;
                default:
                    return true;
            }
        }, props.PropertyConfigurations), t("tool.custom_properties"), (dto_4) => dto_4.CustomProperties, t))))))))))))))))))))))))))))))),
        Controls: empty(),
        Options: {
            BorderStyle: "full",
            CSVDownload: true,
            ConfigurableColumns: false,
            CustomTableFilters: false,
            DefaultSortColumn: ["assignedUserName", "asc"],
            Fullscreen: false,
            GlobalSearch: true,
            OnRowClick: new OnTableRowClick$1(1, [(tool) => RouterModule_encodeParts(ofArray([tool.IsToolWithQuantity ? "toolswithquantity" : (tool.IsSet ? "sets" : "tools"), tool.ToolId]), 1)]),
            RowSelection: "disabled",
            SaveTableConfiguration: false,
            WithQueryParameters: false,
        },
        TableKey: "report-prinzing-tool-assigned-to",
        TableRows: TableRows,
    }))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function SchoeffmannUserReport(props) {
    let elems_2;
    const t = useTranslation()[0];
    const options_1 = orderOptions(map((r_1) => ({
        label: r_1.UserName,
        value: r_1.UserId,
    }), List_distinctBy((r) => r.UserName, props.Reports, {
        Equals: (x, y) => (x === y),
        GetHashCode: (x) => (stringHash(x) | 0),
    })));
    const selectedElement = tryFind((o) => {
        const matchValue = props.State.SelectedUserId;
        if (matchValue == null) {
            return false;
        }
        else {
            return o.value === matchValue[0];
        }
    }, options_1);
    return reactElement("div", createObj(singleton((elems_2 = toList(delay(() => append(singleton_1(createElement(Select, {
        ComponentState: "enabled",
        IsClearable: false,
        NoOptionsMessage: "select.employee_no_options",
        OnChange: (selected) => {
            if (selected == null) {
                props.Dispatch(new Msg(7, [undefined]));
            }
            else {
                const user = selected;
                props.Dispatch(new Msg(7, [[user.value, user.label]]));
            }
        },
        Options: options_1,
        PlaceholderKey: "select.employee_placeholder",
        TestId: "report-user-select",
        Value: unwrap(selectedElement),
    })), delay(() => {
        let children, elems;
        return (props.State.SelectedUserId != null) ? append(singleton_1((children = singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["d-flex", "ml-auto", "mt-2"])], (elems = [createElement(Button, {
            ComponentState: props.State.CsvDownloadActive ? "disabled" : "enabled",
            Label: t("report.print_report"),
            OnClick: () => {
                props.Dispatch(new Msg(13, []));
            },
            TestId: "report-schoeffmannuserreport-print-button",
            Variant: "blueButton",
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), reactElement("div", {
            children: reactApi.Children.toArray(Array.from(children)),
        }))), delay(() => {
            let elems_1, TableRows;
            return singleton_1(reactElement("div", createObj(ofArray([["id", "tools-table"], ["className", join(" ", ["flex", "flex-col"])], (elems_1 = [createElement(Table, (TableRows = toArray(props.Reports), {
                ColumnDefinitions: [new ColumnDefinition$1("qrCodeId", "", t("general.qr_code"), (row) => (new CellContent(0, [row.QrCodeId])), "text", "text"), new ColumnDefinition$1("manufacturer", "", t("tool.manufacturer"), (row_1) => (new CellContent(0, [row_1.Manufacturer])), "text", "text"), new ColumnDefinition$1("model", "", t("tool.model"), (row_2) => (new CellContent(0, [row_2.Model])), "text", "text"), new ColumnDefinition$1("state", "", t("general.state"), (row_3) => (new CellContent(0, [row_3.State])), "text", "text"), new ColumnDefinition$1("serialNumber", "", t("tool.serial_number"), (row_4) => (new CellContent(0, [row_4.SerialNumber])), "text", "text"), new ColumnDefinition$1("lastInpsectionDate", "", t("tool.last_check"), (row_5) => (new CellContent(8, [row_5.LastInspectionDate])), "dateRange", "date"), new ColumnDefinition$1("nextInspectionDate", "", t("tool.next_check"), (row_6) => (new CellContent(8, [row_6.NextInspectionDate])), "dateRange", "date")],
                Controls: empty(),
                Options: {
                    BorderStyle: "full",
                    CSVDownload: true,
                    ConfigurableColumns: false,
                    CustomTableFilters: false,
                    DefaultSortColumn: ["qrCodeId", "asc"],
                    Fullscreen: false,
                    GlobalSearch: true,
                    OnRowClick: new OnTableRowClick$1(1, [(_arg_1) => RouterModule_encodeParts(ofArray(["tools"]), 1)]),
                    RowSelection: "disabled",
                    SaveTableConfiguration: false,
                },
                TableKey: "not-defined-table",
                TableRows: TableRows,
            }))], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))));
        })) : singleton_1(defaultOf());
    })))), ["children", reactApi.Children.toArray(Array.from(elems_2))]))));
}

function SBucherReport(props) {
    let elems_1;
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(undefined);
    const setSelectedConsturctionSiteId = patternInput_1[1];
    const selectedConstructionId = patternInput_1[0];
    const options_1 = orderOptions(map((r_1) => ({
        label: r_1.ConstructionSite,
        value: r_1.ConstructionSiteId,
    }), List_distinctBy((r) => r.ConstructionSite, props.Reports, {
        Equals: (x, y) => (x === y),
        GetHashCode: (x) => (stringHash(x) | 0),
    })));
    const selectedElement = tryFind((o) => {
        if (selectedConstructionId == null) {
            return false;
        }
        else {
            return o.value === selectedConstructionId[0];
        }
    }, options_1);
    return reactElement("div", createObj(singleton((elems_1 = toList(delay(() => append(singleton_1(createElement(Select, {
        ComponentState: "enabled",
        IsClearable: false,
        NoOptionsMessage: "select.construction_site_no_options",
        OnChange: (selected) => {
            if (selected == null) {
                setSelectedConsturctionSiteId(undefined);
            }
            else {
                const site = selected;
                setSelectedConsturctionSiteId([site.value, site.label]);
            }
        },
        Options: options_1,
        PlaceholderKey: "select.construction_site_placeholder",
        TestId: "report-construction-site-select",
        Value: unwrap(selectedElement),
    })), delay(() => {
        let elems, TableRows;
        const matchValue = selectedConstructionId;
        if (matchValue != null) {
            const selectedConstructionId_1 = matchValue;
            return singleton_1(reactElement("div", createObj(ofArray([["id", "tools-table"], ["className", join(" ", ["flex", "flex-col"])], (elems = [createElement(Table, (TableRows = toArray(filter((report) => (report.ConstructionSiteId === selectedConstructionId_1[0]), props.Reports)), {
                ColumnDefinitions: [new ColumnDefinition$1("manufacturer", "", t("tool.manufacturer"), (row) => (new CellContent(0, [row.Manufacturer])), "text", "text"), new ColumnDefinition$1("model", "", t("tool.model"), (row_1) => (new CellContent(0, [row_1.Model])), "text", "text"), new ColumnDefinition$1("inventorynumber", "", t("tool.inventory_number"), (row_2) => (new CellContent(0, [row_2.InventoryNumber])), "text", "text"), new ColumnDefinition$1("assignedDate", "", t("general.delivery_date"), (row_3) => (new CellContent(8, [row_3.AssignDate])), "dateRange", "date"), new ColumnDefinition$1("returnDate", "", t("general.return_date"), (row_4) => (new CellContent(8, [row_4.ReturnDate])), "dateRange", "date")],
                Controls: empty(),
                Options: {
                    BorderStyle: "full",
                    CSVDownload: true,
                    ConfigurableColumns: false,
                    CustomTableFilters: false,
                    DefaultSortColumn: ["manufacturer", "asc"],
                    Fullscreen: false,
                    GlobalSearch: true,
                    OnRowClick: new OnTableRowClick$1(1, [(tool) => RouterModule_encodeParts(ofArray(["tools", tool.ToolId]), 1)]),
                    RowSelection: "disabled",
                    SaveTableConfiguration: false,
                },
                TableKey: "not-defined-table",
                TableRows: TableRows,
            }))], ["children", reactApi.Children.toArray(Array.from(elems))])]))));
        }
        else {
            return singleton_1(defaultOf());
        }
    })))), ["children", reactApi.Children.toArray(Array.from(elems_1))]))));
}

function WassernordConsumableReport(props) {
    let elems_2, elems, elems_1, TableRows;
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(undefined);
    return reactElement("div", createObj(singleton((elems_2 = [reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems = [createElement(GroupedSelect, (($value) => { $value.key = $value.Key; return $value; })({
        ComponentState: "enabled",
        IsClearable: false,
        Key: "select-receiver",
        NoOptionsMessage: "select.employee_no_options",
        OnChange: patternInput_1[1],
        Options: map((tupledArg) => {
            const report = tupledArg[1];
            if (tupledArg[0].tag === 1) {
                return {
                    label: "Baustelle",
                    options: toArray(List_distinctBy((r_3) => r_3.label, map((r_2) => ({
                        label: r_2.ReceiverName,
                        value: r_2,
                    }), report), {
                        Equals: (x_2, y_2) => (x_2 === y_2),
                        GetHashCode: (x_2) => (stringHash(x_2) | 0),
                    })),
                };
            }
            else {
                return {
                    label: "Lager",
                    options: toArray(List_distinctBy((r_1) => r_1.label, map((r) => ({
                        label: r.ReceiverName,
                        value: r,
                    }), report), {
                        Equals: (x_1, y_1) => (x_1 === y_1),
                        GetHashCode: (x_1) => (stringHash(x_1) | 0),
                    })),
                };
            }
        }, List_groupBy((receiver) => receiver.ReceiverType, props.Reports, {
            Equals: equals,
            GetHashCode: (x) => (safeHash(x) | 0),
        })),
        PlaceholderKey: "select.employee_placeholder",
        Value: unwrap(patternInput_1[0]),
    }))], ["children", reactApi.Children.toArray(Array.from(elems))])]))), reactElement("div", createObj(ofArray([["id", "wassernord-tools-table"], ["className", join(" ", ["flex", "flex-col"])], (elems_1 = [createElement(Table, (TableRows = toArray(props.Reports), {
        ColumnDefinitions: [new ColumnDefinition$1("name", "", t("general.name"), (row) => (new CellContent(0, [row.Name])), "text", "text"), new ColumnDefinition$1("additionalName", "", t("consumable.additional_name"), (row_1) => (new CellContent(0, [row_1.AdditionalName])), "text", "text"), new ColumnDefinition$1("supplierArticleNumber", "", t("general.supplier_article_number"), (row_2) => (new CellContent(0, [row_2.SupplierArticleNumber])), "text", "text"), new ColumnDefinition$1("senderName", "", t("general.sender"), (row_3) => (new CellContent(0, [row_3.SenderName])), "text", "text"), new ColumnDefinition$1("receiver", "", t("general.receiver"), (row_4) => (new CellContent(0, [row_4.ReceiverName])), "text", "text"), new ColumnDefinition$1("quatity", "", t("general.quantity_2"), (row_5) => (new CellContent(0, [row_5.Quantity.toString()])), "text", "text")],
        Controls: empty(),
        Options: {
            BorderStyle: "full",
            CSVDownload: true,
            ConfigurableColumns: false,
            CustomTableFilters: false,
            DefaultSortColumn: ["name", "asc"],
            Fullscreen: false,
            GlobalSearch: true,
            OnRowClick: new OnTableRowClick$1(1, [(_arg) => RouterModule_encodeParts(ofArray(["tools", "view", "toolwithquantity"]), 1)]),
            RowSelection: "disabled",
            SaveTableConfiguration: false,
        },
        TableKey: "not-defined-table",
        TableRows: TableRows,
    }))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))]))));
}

function ProblemReportsReport(props) {
    let elems, TableRows;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["id", "problemreports-tools-table"], ["data-test-id", "problemreports-tools-table"], ["className", join(" ", ["flex", "flex-col"])], (elems = [createElement(Table, (TableRows = toArray(props.Reports), {
        ColumnDefinitions: [new ColumnDefinition$1("timestamp", "", t("general.date"), (row) => (new CellContent(8, [row.Timestamp])), "text", "date"), new ColumnDefinition$1("senderName", "", t("general.sender"), (row_1) => (new CellContent(0, [row_1.SenderName])), "select", "text"), new ColumnDefinition$1("inititalMessage", "", t("report.problem_report.message"), (row_2) => (new CellContent(0, [row_2.InititalMessage])), "text", "text"), new ColumnDefinition$1("serialNumber", "", t("tool.serial_number"), (row_3) => (new CellContent(0, [row_3.SerialNumber])), "text", "text"), new ColumnDefinition$1("model", "", t("tool.model"), (row_4) => (new CellContent(0, [row_4.Model])), "text", "text"), new ColumnDefinition$1("manufacturer", "", t("tool.manufacturer"), (row_5) => (new CellContent(0, [row_5.Manufacturer])), "text", "text"), new ColumnDefinition$1("displayName", "", t("tool.displayname"), (row_6) => (new CellContent(0, [row_6.DisplayName])), "text", "text"), new ColumnDefinition$1("inventoryNumber", "", t("general.inventory_number"), (row_7) => (new CellContent(0, [row_7.InventoryNumber])), "text", "text")],
        Controls: empty(),
        Options: {
            BorderStyle: "full",
            CSVDownload: true,
            ConfigurableColumns: false,
            CustomTableFilters: false,
            DefaultSortColumn: ["timestamp", "asc"],
            Fullscreen: false,
            GlobalSearch: true,
            OnRowClick: new OnTableRowClick$1(1, [(tool) => RouterModule_encodeParts(ofArray(["tools", unwrapToolId(tool.ToolId) + RouterModule_encodeQueryString(singleton(["problemReportId", ProblemReportId__get_unwrap(tool.ProblemReportId)]))]), 1)]),
            RowSelection: "disabled",
            SaveTableConfiguration: false,
        },
        TableKey: "not-defined-table",
        TableRows: TableRows,
    }))], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function MinimumStockQuantityReport(props) {
    let elems_2, elems_1, elems, TableRows;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["className", "flex-grow-1 d-flex flex-column"], (elems_2 = [reactElement("div", createObj(ofArray([["id", "minimumstockquantity"], ["className", "tab-pane"], ["children", "Minimumstockquantity"], (elems_1 = [reactElement("div", createObj(ofArray([["id", "tools-table"], ["className", join(" ", ["flex", "flex-col"])], (elems = [createElement(Table, (TableRows = toArray(props.Reports), {
        ColumnDefinitions: [new ColumnDefinition$1("displayName", "", t("general.tool"), (row) => (new CellContent(0, [row.DisplayName])), "text", "text"), new ColumnDefinition$1("manufacturer", "", t("tool.manufacturer"), (row_1) => (new CellContent(0, [row_1.Manufacturer])), "text", "text"), new ColumnDefinition$1("model", "", t("tool.model"), (row_2) => (new CellContent(0, [row_2.Model])), "text", "text"), new ColumnDefinition$1("inventoryNumber", "", t("general.inventory_number"), (row_3) => (new CellContent(0, [row_3.InventoryNumber])), "text", "text"), new ColumnDefinition$1("storageStock", "", t("general.stock"), (row_4) => (new CellContent(0, [row_4.StorageStock])), "text", "text"), new ColumnDefinition$1("minimumStock", "", t("general.minimum_quantity"), (row_5) => (new CellContent(0, [row_5.MinimumStock])), "text", "text"), new ColumnDefinition$1("storageName", "", t("general.storage"), (row_6) => (new CellContent(0, [row_6.StorageName])), "select", "text"), new ColumnDefinition$1("storageSpace", "", t("tool.storage_space"), (row_7) => (new CellContent(0, [row_7.StorageSpace])), "text", "text"), new ColumnDefinition$1("supplierArticleNumber", t("tool.commercial_data"), t("general.supplier_article_number"), (dto) => (new CellContent(0, [dto.CommercialData.SupplierArticleNumber])), "text", "text"), new ColumnDefinition$1("supplier", t("tool.commercial_data"), t("general.supplier"), (dto_1) => (new CellContent(0, [dto_1.CommercialData.Supplier])), "text", "text"), new ColumnDefinition$1("purchaseDate", t("tool.commercial_data"), t("general.purchase_date"), (dto_2) => (new CellContent(8, [dto_2.CommercialData.PurchaseDate])), "text", "date"), new ColumnDefinition$1("guranteeDate", t("tool.commercial_data"), t("general.gurantee_date"), (dto_3) => (new CellContent(8, [dto_3.CommercialData.WarrantyDate])), "text", "date"), new ColumnDefinition$1("purchasePrice", t("tool.commercial_data"), t("general.purchase_price"), (dto_4) => {
            const matchValue = dto_4.CommercialData.PurchasePrice;
            return (matchValue != null) ? (new CellContent(0, [priceToString(matchValue, props.Configuration.Currency)])) : (new CellContent(0, [""]));
        }, "text", "text")],
        Controls: empty(),
        Options: {
            BorderStyle: "full",
            CSVDownload: true,
            ConfigurableColumns: false,
            CustomTableFilters: false,
            DefaultSortColumn: ["displayName", "asc"],
            Fullscreen: false,
            GlobalSearch: true,
            OnRowClick: new OnTableRowClick$1(1, [(row_8) => {
                const matchValue_1 = row_8.ToolId;
                const matchValue_2 = row_8.ConsumableId;
                return (matchValue_1 != null) ? RouterModule_encodeParts(ofArray(["toolswithquantity", unwrapToolId(matchValue_1)]), 1) : ((matchValue_2 != null) ? RouterModule_encodeParts(ofArray(["consumables", unwrapConsumableId(matchValue_2)]), 1) : RouterModule_encodeParts(ofArray(["tools"]), 1));
            }]),
            RowSelection: "disabled",
            SaveTableConfiguration: false,
        },
        TableKey: "not-defined-table",
        TableRows: TableRows,
    }))], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

function PlannedReturnDateReport(props) {
    let elems_2, elems_1, elems, TableRows;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["className", "flex-grow-1 d-flex flex-column"], (elems_2 = [reactElement("div", createObj(ofArray([["id", "plannedreturndate"], ["className", "tab-pane"], ["children", "plannedreturndate"], (elems_1 = [reactElement("div", createObj(ofArray([["id", "tools-table"], ["className", join(" ", ["flex", "flex-col"])], (elems = [createElement(Table, (TableRows = toArray(props.Reports), {
        ColumnDefinitions: [new ColumnDefinition$1("date", "", t("general.date"), (row) => (new CellContent(8, [row.Date])), "text", "date"), new ColumnDefinition$1("receiverName", "", t("general.receiver"), (row_1) => (new CellContent(0, [row_1.ReceiverName])), "select", "text"), new ColumnDefinition$1("displayName", "", t("general.tool"), (row_2) => (new CellContent(0, [row_2.DisplayName])), "text", "text"), new ColumnDefinition$1("manufacturer", "", t("tool.manufacturer"), (row_3) => (new CellContent(0, [row_3.Manufacturer])), "text", "text"), new ColumnDefinition$1("model", "", t("tool.model"), (row_4) => (new CellContent(0, [row_4.Model])), "text", "text"), new ColumnDefinition$1("serialNumber", "", t("tool.serial_number"), (row_5) => (new CellContent(0, [row_5.SerialNumber])), "text", "text"), new ColumnDefinition$1("inventoryNumber", "", t("general.inventory_number"), (row_6) => (new CellContent(0, [row_6.InventoryNumber])), "text", "text")],
        Controls: empty(),
        Options: {
            BorderStyle: "full",
            CSVDownload: true,
            ConfigurableColumns: false,
            CustomTableFilters: false,
            DefaultSortColumn: ["date", "asc"],
            Fullscreen: false,
            GlobalSearch: true,
            OnRowClick: new OnTableRowClick$1(1, [(row_7) => RouterModule_encodeParts(ofArray(["tools", unwrapToolId(row_7.ToolId)]), 1)]),
            RowSelection: "disabled",
            SaveTableConfiguration: false,
        },
        TableKey: "not-defined-table",
        TableRows: TableRows,
    }))], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

function NextReservationsReport(props) {
    let elems_2, elems_1, elems, TableRows;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["className", "flex-grow-1 d-flex flex-column"], (elems_2 = [reactElement("div", createObj(ofArray([["id", "nextreservations"], ["className", "tab-pane"], ["children", "nextreservations"], (elems_1 = [reactElement("div", createObj(ofArray([["id", "tools-table"], ["className", join(" ", ["flex", "flex-col"])], (elems = [createElement(Table, (TableRows = toArray(props.Reports), {
        ColumnDefinitions: [new ColumnDefinition$1("startDate", "", t("general.start_date"), (row) => (new CellContent(8, [row.StartDate])), "text", "date"), new ColumnDefinition$1("ReturnDate", "", t("general.end_date"), (row_1) => (new CellContent(8, [row_1.ReturnDate])), "text", "date"), new ColumnDefinition$1("reservationName", "", t("general.name"), (row_2) => (new CellContent(0, [row_2.ReservationName])), "text", "text"), new ColumnDefinition$1("currentReceiverName", "", t("general.current_receiver"), (dto) => {
            const matchValue = dto.ReceiverInformation.CurrentReceiverOnClickPath;
            if (matchValue == null) {
                return new CellContent(0, [""]);
            }
            else {
                const onClickPath = matchValue;
                return new CellContent(3, [dto.ReceiverInformation.CurrentReceiverName, () => {
                    RouterModule_nav(ofArray(toArray(onClickPath)), 1, 1);
                }]);
            }
        }, "select", "button"), new ColumnDefinition$1("receiverName", "", t("general.receiver"), (dto_1) => (new CellContent(3, [dto_1.ReceiverInformation.ReceiverName, () => {
            RouterModule_nav(ofArray(toArray(dto_1.ReceiverInformation.ReceiverNameOnClickPath)), 1, 1);
        }])), "select", "button"), new ColumnDefinition$1("displayName", "", t("general.tool"), (dto_2) => (new CellContent(3, [dto_2.DisplayName, () => {
            RouterModule_nav(ofArray(toArray(dto_2.ToolInformation.OnClickPath)), 1, 1);
        }])), "text", "button"), new ColumnDefinition$1("manufacturer", "", t("tool.manufacturer"), (row_3) => (new CellContent(0, [row_3.Manufacturer])), "text", "text"), new ColumnDefinition$1("model", "", t("tool.model"), (row_4) => (new CellContent(0, [row_4.Model])), "text", "text"), new ColumnDefinition$1("serialNumber", "", t("tool.serial_number"), (row_5) => (new CellContent(0, [row_5.SerialNumber])), "text", "text"), new ColumnDefinition$1("inventoryNumber", "", t("general.inventory_number"), (row_6) => (new CellContent(0, [row_6.InventoryNumber])), "text", "text"), new ColumnDefinition$1("quantity", "", t("general.quantity"), (row_7) => (new CellContent(0, [defaultArg(row_7.ToolInformation.Quantity, "")])), "text", "text"), new ColumnDefinition$1("unit", "", t("general.unit"), (row_8) => (new CellContent(0, [t(row_8.ToolInformation.Unit)])), "select", "text")],
        Controls: empty(),
        Options: {
            BorderStyle: "full",
            CSVDownload: true,
            ConfigurableColumns: false,
            CustomTableFilters: false,
            DefaultSortColumn: ["startDate", "asc"],
            Fullscreen: false,
            GlobalSearch: true,
            OnRowClick: new OnTableRowClick$1(1, [(dto_3) => {
                let matchValue_1;
                return RouterModule_encodeParts(ofArray(["reservations", (matchValue_1 = dto_3.GroupReservationId, (matchValue_1 == null) ? dto_3.ReservationId : matchValue_1)]), 1);
            }]),
            RowSelection: "disabled",
            SaveTableConfiguration: false,
        },
        TableKey: "not-defined-table",
        TableRows: TableRows,
    }))], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

function ReportResultContent(props) {
    let elems_1;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["h-full"])], (elems_1 = toList(delay(() => {
        let children, elems;
        if (props.State.FormState.IsLoading) {
            return singleton_1(createElement(Skeleton, {
                Variant: "table",
            }));
        }
        else {
            const matchValue = props.State.ReportResult;
            const matchValue_1 = props.State.PropertyConfiguration;
            let matchResult, propertyConfiguration, reportResult;
            if (matchValue == null) {
                matchResult = 1;
            }
            else if (matchValue_1.tag === 0) {
                matchResult = 1;
            }
            else {
                matchResult = 0;
                propertyConfiguration = matchValue_1.fields[0];
                reportResult = matchValue;
            }
            switch (matchResult) {
                case 0: {
                    const matchValue_3 = reportResult;
                    let matchResult_1, result_14;
                    switch (matchValue_3.tag) {
                        case 1: {
                            matchResult_1 = 1;
                            break;
                        }
                        case 2: {
                            matchResult_1 = 2;
                            break;
                        }
                        case 8: {
                            matchResult_1 = 3;
                            break;
                        }
                        case 3: {
                            matchResult_1 = 4;
                            break;
                        }
                        case 25: {
                            matchResult_1 = 5;
                            break;
                        }
                        case 4: {
                            matchResult_1 = 6;
                            break;
                        }
                        case 6: {
                            matchResult_1 = 7;
                            break;
                        }
                        case 5: {
                            matchResult_1 = 8;
                            break;
                        }
                        case 12: {
                            matchResult_1 = 9;
                            break;
                        }
                        case 7: {
                            matchResult_1 = 10;
                            break;
                        }
                        case 9: {
                            matchResult_1 = 11;
                            break;
                        }
                        case 10: {
                            matchResult_1 = 12;
                            break;
                        }
                        case 11: {
                            matchResult_1 = 13;
                            break;
                        }
                        case 13: {
                            matchResult_1 = 14;
                            break;
                        }
                        case 36: {
                            matchResult_1 = 15;
                            break;
                        }
                        case 14: {
                            matchResult_1 = 16;
                            result_14 = matchValue_3.fields[0];
                            break;
                        }
                        case 15: {
                            matchResult_1 = 16;
                            result_14 = matchValue_3.fields[0];
                            break;
                        }
                        case 16: {
                            matchResult_1 = 17;
                            break;
                        }
                        case 17: {
                            matchResult_1 = 18;
                            break;
                        }
                        case 18: {
                            matchResult_1 = 19;
                            break;
                        }
                        case 19: {
                            matchResult_1 = 20;
                            break;
                        }
                        case 20: {
                            matchResult_1 = 21;
                            break;
                        }
                        case 21: {
                            matchResult_1 = 22;
                            break;
                        }
                        case 22: {
                            matchResult_1 = 23;
                            break;
                        }
                        case 23: {
                            matchResult_1 = 24;
                            break;
                        }
                        case 24: {
                            matchResult_1 = 25;
                            break;
                        }
                        case 26: {
                            matchResult_1 = 26;
                            break;
                        }
                        case 27: {
                            matchResult_1 = 27;
                            break;
                        }
                        case 32: {
                            matchResult_1 = 28;
                            break;
                        }
                        case 34: {
                            matchResult_1 = 29;
                            break;
                        }
                        case 35: {
                            matchResult_1 = 30;
                            break;
                        }
                        case 28: {
                            matchResult_1 = 31;
                            break;
                        }
                        case 29: {
                            matchResult_1 = 32;
                            break;
                        }
                        case 30: {
                            matchResult_1 = 33;
                            break;
                        }
                        case 31: {
                            matchResult_1 = 34;
                            break;
                        }
                        case 33: {
                            matchResult_1 = 35;
                            break;
                        }
                        default:
                            matchResult_1 = 0;
                    }
                    switch (matchResult_1) {
                        case 0:
                            return singleton_1(createElement(ConsumableByCommissionnumberView, {
                                Dispatch: props.Dispatch,
                                Reports: matchValue_3.fields[0],
                                State: props.State,
                            }));
                        case 1:
                            return singleton_1(createElement(ProblemReportsPerToolView, {
                                Dispatch: props.Dispatch,
                                Reports: matchValue_3.fields[0],
                                State: props.State,
                            }));
                        case 2:
                            return singleton_1(createElement(AppointmentsView, {
                                Configuration: props.Configuration,
                                Dispatch: props.Dispatch,
                                PropertyConfigurations: propertyConfiguration,
                                Reports: matchValue_3.fields[0],
                                State: props.State,
                            }));
                        case 3:
                            return singleton_1(createElement(MissedAppointmentsView, {
                                Configuration: props.Configuration,
                                Dispatch: props.Dispatch,
                                PropertyConfigurations: propertyConfiguration,
                                Reports: matchValue_3.fields[0],
                                State: props.State,
                            }));
                        case 4:
                            return singleton_1(createElement(ToolsRemovalsOrEntriesByDateRangeOverview, {
                                Configuration: props.Configuration,
                                PropertyConfigurations: propertyConfiguration,
                                State: props.State,
                                Tools: matchValue_3.fields[0],
                                WithEntryTypeColumn: false,
                            }));
                        case 5:
                            return singleton_1(createElement(ToolsRemovalsOrEntriesByDateRangeOverview, {
                                Configuration: props.Configuration,
                                PropertyConfigurations: propertyConfiguration,
                                State: props.State,
                                Tools: matchValue_3.fields[0],
                                WithEntryTypeColumn: true,
                            }));
                        case 6:
                            return singleton_1(createElement(SchoeffmannRetiredToolsWithQRCodeId, {
                                State: props.State,
                                Tools: matchValue_3.fields[0],
                            }));
                        case 7:
                            return singleton_1(createElement(SchoeffmannActiveAndInMaintenanceToolsWithQRCodeId, {
                                State: props.State,
                                Tools: matchValue_3.fields[0],
                            }));
                        case 8:
                            return singleton_1(createElement(ReservationsByDaterangeReport, {
                                State: props.State,
                                Tools: matchValue_3.fields[0],
                            }));
                        case 9:
                            return singleton_1(createElement(WithoutReservationsByDateRangeReport, {
                                State: props.State,
                                Tools: matchValue_3.fields[0],
                            }));
                        case 10:
                            return singleton_1(createElement(PrinzingReportAssignedToolsWithLastComment, {
                                Configuration: props.Configuration,
                                Dispatch: props.Dispatch,
                                PropertyConfigurations: propertyConfiguration,
                                State: props.State,
                                Tools: matchValue_3.fields[0],
                            }));
                        case 11:
                            return singleton_1(createElement(SchoeffmannUserReport, {
                                Dispatch: props.Dispatch,
                                Reports: matchValue_3.fields[0],
                                State: props.State,
                            }));
                        case 12:
                            return singleton_1(createElement(SBucherReport, {
                                Dispatch: props.Dispatch,
                                Reports: matchValue_3.fields[0],
                                State: props.State,
                            }));
                        case 13:
                            return singleton_1(createElement(WassernordConsumableReport, {
                                Dispatch: props.Dispatch,
                                Reports: matchValue_3.fields[0],
                                State: props.State,
                            }));
                        case 14:
                            return singleton_1((children = singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["d-flex", "mt-2"])], (elems = [createElement(Button, {
                                ComponentState: props.State.CsvDownloadActive ? "disabled" : "enabled",
                                Label: t("report.print_report"),
                                OnClick: () => {
                                    props.Dispatch(new Msg(13, []));
                                },
                                TestId: "report-printreport-button",
                                Variant: "primary",
                            })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), reactElement("div", {
                                children: reactApi.Children.toArray(Array.from(children)),
                            })));
                        case 15:
                            return singleton_1(defaultOf());
                        case 16:
                            return singleton_1(createElement(ProblemReportsReport, {
                                Dispatch: props.Dispatch,
                                Reports: result_14,
                                State: props.State,
                            }));
                        case 17:
                            return singleton_1(createElement(OpenAppointmentsView, {
                                Configuration: props.Configuration,
                                Dispatch: props.Dispatch,
                                PropertyConfigurations: propertyConfiguration,
                                Reports: matchValue_3.fields[0],
                                State: props.State,
                            }));
                        case 18:
                            return singleton_1(createElement(MinimumStockQuantityReport, {
                                Configuration: props.Configuration,
                                Dispatch: props.Dispatch,
                                Reports: matchValue_3.fields[0],
                                State: props.State,
                            }));
                        case 19:
                            return singleton_1(createElement(PlannedReturnDateReport, {
                                Dispatch: props.Dispatch,
                                Reports: matchValue_3.fields[0],
                                State: props.State,
                            }));
                        case 20:
                            return singleton_1(createElement(NextReservationsReport, {
                                Dispatch: props.Dispatch,
                                Reports: matchValue_3.fields[0],
                                State: props.State,
                            }));
                        case 21:
                            return singleton_1(createElement(PrinzingBaustromReport, {
                                ConstructionSites: matchValue_3.fields[0].ConstructionSites,
                                CustomerConfiguration: props.Configuration,
                            }));
                        case 22: {
                            const matchValue_4 = props.State.SelectedStorageId;
                            return (matchValue_4 == null) ? singleton_1(reactElement("div", {
                                children: ["No storage selected."],
                            })) : singleton_1(createElement(SwissAthleticReport, {
                                EndDate: props.State.EndDate,
                                StartDate: props.State.StartDate,
                                StorageId: matchValue_4,
                                SwissAthleticReportResult: matchValue_3.fields[0],
                            }));
                        }
                        case 23:
                            return singleton_1(createElement(ReportView, {
                                Report: matchValue_3.fields[0],
                            }));
                        case 24:
                            return singleton_1(createElement(Report, {
                                ConstructionSites: matchValue_3.fields[0].ConstructionSites,
                                CustomerConfiguration: props.Configuration,
                            }));
                        case 25:
                            return singleton_1(createElement(ReportView_1, {
                                Report: matchValue_3.fields[0],
                            }));
                        case 26:
                            return singleton_1(createElement(ReportView_2, {
                                CustomerConfiguration: props.Configuration,
                                PropertyConfigurations: propertyConfiguration,
                                Report: matchValue_3.fields[0],
                            }));
                        case 27:
                            return singleton_1(createElement(ReportView_3, {
                                PropertyConfigurations: propertyConfiguration,
                                Report: matchValue_3.fields[0],
                            }));
                        case 28:
                            return singleton_1(createElement(ReportView_4, {
                                Configuration: props.Configuration,
                                PropertyConfigurations: propertyConfiguration,
                                Report: matchValue_3.fields[0],
                            }));
                        case 29:
                            return singleton_1(createElement(ReportView_5, {
                                Configuration: props.Configuration,
                                PropertyConfigurations: propertyConfiguration,
                                Report: matchValue_3.fields[0],
                            }));
                        case 30:
                            return singleton_1(createElement(ReportView_6, {
                                Report: matchValue_3.fields[0],
                            }));
                        case 31:
                            return singleton_1(createElement(ReportView_7, {
                                PropertyConfigurations: propertyConfiguration,
                                Report: matchValue_3.fields[0],
                            }));
                        case 32:
                            return singleton_1(createElement(ReportView_8, {
                                Customer: props.State.Customer,
                                PropertyConfigurations: propertyConfiguration,
                                Report: matchValue_3.fields[0],
                                SelectedDuplicateCheckType: unwrap(props.State.SelectedDuplicateCheckType),
                            }));
                        case 33:
                            return singleton_1(createElement(ReportView_9, {
                                Configuration: props.Configuration,
                                Customer: props.State.Customer,
                                PropertyConfigurations: propertyConfiguration,
                                Report: matchValue_3.fields[0],
                            }));
                        case 34:
                            return singleton_1(createElement(ReportView_10, {
                                Configuration: props.Configuration,
                                Customer: props.State.Customer,
                                PropertyConfigurations: propertyConfiguration,
                                Report: matchValue_3.fields[0],
                            }));
                        default:
                            return singleton_1(createElement(ReportView_11, {
                                Configuration: props.Configuration,
                                Customer: props.State.Customer,
                                PropertyConfigurations: propertyConfiguration,
                                Report: matchValue_3.fields[0],
                            }));
                    }
                }
                default:
                    return singleton_1(createElement(InformationAlert, {
                        Label: t("report.report_not_selected_msg"),
                    }));
            }
        }
    })), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function ReportControl(props) {
    let elems_15;
    const t = useTranslation()[0];
    const filteredReports = filter((r) => {
        if (isEmpty(r.OnlyVisibleForCustomer)) {
            return true;
        }
        else {
            return contains(props.State.Customer, r.OnlyVisibleForCustomer, {
                Equals: equals,
                GetHashCode: (x) => (safeHash(x) | 0),
            });
        }
    }, Helper_reports);
    const groupedOptions = map((tupledArg_1) => ({
        label: t(Helper_categoryI18NLabel(tupledArg_1[0])),
        options: toArray(map((r_2) => ({
            label: t(r_2.I18NLabel),
            value: r_2.Id,
        }), sortBy((r_1) => t(r_1.I18NLabel).toLowerCase(), tupledArg_1[1], {
            Compare: (x_3, y_3) => (comparePrimitives(x_3, y_3) | 0),
        }))),
    }), sortBy((tupledArg) => (Helper_categoryOrder(tupledArg[0]) | 0), List_groupBy((_arg) => _arg.Category, filteredReports, {
        Equals: equals,
        GetHashCode: (x_1) => (safeHash(x_1) | 0),
    }), {
        Compare: (x_2, y_2) => (comparePrimitives(x_2, y_2) | 0),
    }));
    const selectedReportOption = map_1((r_4) => ({
        label: t(r_4.I18NLabel),
        value: r_4.Id,
    }), tryFind((r_3) => {
        const matchValue = props.State.SelectedReportId;
        if (matchValue == null) {
            return false;
        }
        else {
            return matchValue === r_3.Id;
        }
    }, filteredReports));
    return reactElement("div", createObj(ofArray([["className", join(" ", ["max-w-[60%]"])], (elems_15 = toList(delay(() => {
        let elems;
        return append(singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["mb-4"])], (elems = [createElement(GroupedSelect, (($value) => { $value.key = $value.Key; return $value; })({
            ComponentState: "enabled",
            IsClearable: false,
            Key: "report-select",
            Label: t("report.choose_report"),
            NoOptionsMessage: "report.report_select_not_found",
            OnChange: (s) => {
                props.Dispatch(new Msg(6, [value_36(s).value]));
            },
            Options: groupedOptions,
            PlaceholderKey: "report.report_select_placeholder",
            Value: unwrap(selectedReportOption),
        }))], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
            let elems_4, elems_3, elems_1, elems_2;
            const matchValue_1 = props.State.SelectedReportId;
            if (matchValue_1 != null) {
                const reportId = matchValue_1 | 0;
                return append(Helper_hasReportDaterangeOption(reportId) ? singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems_4 = [createElement(TextValue, {
                    FontWeight: "bold",
                    TestId: "",
                    Text: t("report.choose_timerange"),
                }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "mt-4", "gap-4"])], (elems_3 = [reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems_1 = [createElement(DatePicker, {
                    ComponentState: "enabled",
                    IsClearable: false,
                    Label: t("report.from"),
                    MaxDate: props.State.EndDate,
                    OnChange: (d) => {
                        if (d != null) {
                            props.Dispatch(new Msg(1, [d]));
                        }
                    },
                    TestId: "report-from-date",
                    Value: props.State.StartDate,
                })], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems_2 = [createElement(DatePicker, {
                    ComponentState: "enabled",
                    IsClearable: false,
                    Label: t("report.to"),
                    MinDate: props.State.StartDate,
                    OnChange: (d_2) => {
                        if (d_2 != null) {
                            props.Dispatch(new Msg(2, [d_2]));
                        }
                    },
                    TestId: "report-to-date",
                    Value: props.State.EndDate,
                })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))) : empty_1(), delay(() => {
                    let matchValue_2, report_1, matchValue_3, options, elems_5;
                    return append((matchValue_2 = Helper_reportById(reportId), (matchValue_2 != null) ? (equals(matchValue_2.Type, new ReportType(21, [])) ? ((report_1 = matchValue_2, (matchValue_3 = props.State.Storages, (matchValue_3.tag === 0) ? singleton_1(createElement(Skeleton, {
                        Variant: "normal",
                    })) : ((options = map((storage) => ({
                        label: Storage__get_DisplayName(storage),
                        value: storage.Id,
                    }), matchValue_3.fields[0]), singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["mt-4"])], (elems_5 = [createElement(Select, {
                        ComponentState: "enabled",
                        IsClearable: false,
                        Label: t("general.storage"),
                        NoOptionsMessage: "",
                        OnChange: (selectedOption) => {
                            props.Dispatch(new Msg(8, [map_1((option_1) => option_1.value, selectedOption)]));
                        },
                        Options: options,
                        PlaceholderKey: "",
                        TestId: "report-storage-select",
                        Value: unwrap(flatten(map_1((selectedStorageId) => tryFind((option_3) => equals(option_3.value, selectedStorageId), options), props.State.SelectedStorageId))),
                    })], ["children", reactApi.Children.toArray(Array.from(elems_5))])]))))))))) : (empty_1())) : (empty_1())), delay(() => {
                        let matchValue_4, report_3, elems_9, elems_8, elems_6, elems_7;
                        return append((matchValue_4 = Helper_reportById(reportId), (matchValue_4 != null) ? (equals(matchValue_4.Type, new ReportType(28, [])) ? ((report_3 = matchValue_4, singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["mt-5"])], (elems_9 = [createElement(TextValue, {
                            FontWeight: "bold",
                            TestId: "",
                            Text: t("general.created_at"),
                        }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "mt-4", "gap-4"])], (elems_8 = [reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems_6 = [createElement(DatePicker, {
                            ComponentState: "enabled",
                            IsClearable: false,
                            Label: t("report.from"),
                            MaxDate: unwrap(props.State.CreatedEndDate),
                            OnChange: (d_4) => {
                                if (d_4 != null) {
                                    props.Dispatch(new Msg(3, [d_4]));
                                }
                            },
                            TestId: "report-from-date",
                            Value: unwrap(props.State.CreatedStartDate),
                        })], ["children", reactApi.Children.toArray(Array.from(elems_6))])]))), reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems_7 = [createElement(DatePicker, {
                            ComponentState: "enabled",
                            IsClearable: false,
                            Label: t("report.to"),
                            MinDate: unwrap(props.State.CreatedStartDate),
                            OnChange: (d_6) => {
                                if (d_6 != null) {
                                    props.Dispatch(new Msg(4, [d_6]));
                                }
                            },
                            TestId: "report-to-date",
                            Value: unwrap(props.State.CreatedEndDate),
                        })], ["children", reactApi.Children.toArray(Array.from(elems_7))])])))], ["children", reactApi.Children.toArray(Array.from(elems_8))])])))], ["children", reactApi.Children.toArray(Array.from(elems_9))])])))))) : (empty_1())) : (empty_1())), delay(() => {
                            let matchValue_5, report_5, options_1, elems_10, Label_6, Value_5;
                            return append((matchValue_5 = Helper_reportById(reportId), (matchValue_5 != null) ? (equals(matchValue_5.Type, new ReportType(29, [])) ? ((report_5 = matchValue_5, (options_1 = ofArray([{
                                label: t("general.inventory_number"),
                                value: new DuplicateCheckType(0, []),
                            }, {
                                label: t("tool.serial_number"),
                                value: new DuplicateCheckType(1, []),
                            }]), singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["mt-4"])], (elems_10 = [createElement(Select, (Label_6 = t("report.report_duplicate_choose_field"), (Value_5 = flatten(map_1((selectedDuplicateCheckType) => tryFind((option_8) => equals(option_8.value, selectedDuplicateCheckType), options_1), props.State.SelectedDuplicateCheckType)), {
                                ComponentState: "enabled",
                                IsClearable: false,
                                Label: unwrap(Label_6),
                                NoOptionsMessage: "",
                                OnChange: (selectedOption_1) => {
                                    props.Dispatch(new Msg(9, [map_1((option_6) => option_6.value, selectedOption_1)]));
                                },
                                Options: options_1,
                                PlaceholderKey: "",
                                TestId: "report-duplicate-field-select",
                                ValidationMessage: unwrap(FormState__getValidation(props.State.FormState, t, "duplicateCheckType")),
                                Value: unwrap(Value_5),
                            })))], ["children", reactApi.Children.toArray(Array.from(elems_10))])]))))))) : (empty_1())) : (empty_1())), delay(() => {
                                let matchValue_6, report_6, report_8, matchValue_7, options_2, selectedValues, elems_11, report_9, matchValue_8, options_3, selectedValue, elems_12;
                                return append((matchValue_6 = Helper_reportById(reportId), (matchValue_6 != null) ? (((report_6 = matchValue_6, equals(report_6.Type, new ReportType(31, [])) ? true : equals(report_6.Type, new ReportType(30, [])))) ? ((report_8 = matchValue_6, (matchValue_7 = props.State.InspectionTemplates, (matchValue_7.tag === 0) ? singleton_1(createElement(Skeleton, {
                                    Variant: "normal",
                                })) : ((options_2 = map((template) => ({
                                    label: template.Name,
                                    value: template.Id,
                                }), matchValue_7.fields[0]), (selectedValues = choose((selectedId) => tryFind((o) => (o.value === selectedId), options_2), props.State.SelectedInspectionTemplateIds), singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["mt-4"])], (elems_11 = [createElement(MultiSelect, {
                                    ComponentState: "enabled",
                                    IsClearable: true,
                                    Label: t("report.inspection_statistics_choose_templates"),
                                    NoOptionsMessage: "report.inspection_statistics_no_templates",
                                    OnChange: (selectedOptions) => {
                                        props.Dispatch(new Msg(10, [defaultArg(map_1((opts) => map((o_1) => o_1.value, ofArray(opts)), selectedOptions), empty())]));
                                    },
                                    Options: options_2,
                                    PlaceholderKey: "report.inspection_statistics_templates_placeholder",
                                    TestId: "inspection-statistics-template-select",
                                    Value: selectedValues,
                                })], ["children", reactApi.Children.toArray(Array.from(elems_11))])])))))))))) : (equals(matchValue_6.Type, new ReportType(33, [])) ? ((report_9 = matchValue_6, (matchValue_8 = props.State.InspectionTemplates, (matchValue_8.tag === 0) ? singleton_1(createElement(Skeleton, {
                                    Variant: "normal",
                                })) : ((options_3 = map((template_1) => ({
                                    label: template_1.Name,
                                    value: template_1.Id,
                                }), matchValue_8.fields[0]), (selectedValue = bind((selectedId_1) => tryFind((o_2) => (o_2.value === selectedId_1), options_3), tryHead(props.State.SelectedInspectionTemplateIds)), append(singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["mt-4"])], (elems_12 = [createElement(Select, {
                                    ComponentState: "enabled",
                                    IsClearable: true,
                                    Label: t("report.inspection_calendar_choose_template"),
                                    NoOptionsMessage: "report.inspection_statistics_no_templates",
                                    OnChange: (selectedOption_2) => {
                                        props.Dispatch(new Msg(10, [defaultArg(map_1((o_3) => singleton(o_3.value), selectedOption_2), empty())]));
                                    },
                                    Options: options_3,
                                    PlaceholderKey: "report.inspection_calendar_template_placeholder",
                                    TestId: "inspection-calendar-template-select",
                                    Value: unwrap(selectedValue),
                                })], ["children", reactApi.Children.toArray(Array.from(elems_12))])])))), delay(() => {
                                    let elems_13;
                                    return singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["mt-4"])], (elems_13 = [Checkbox({
                                        ComponentState: "enabled",
                                        IsChecked: props.State.IncludeUninspected,
                                        Label: t("report.inspection_calendar_include_uninspected"),
                                        OnCheck: (value_31) => {
                                            props.Dispatch(new Msg(11, [value_31]));
                                        },
                                        TestId: "inspection-calendar-include-uninspected",
                                    })], ["children", reactApi.Children.toArray(Array.from(elems_13))])]))));
                                })))))))) : (empty_1()))) : (empty_1())), delay(() => {
                                    let elems_14;
                                    return singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["mt-4"])], (elems_14 = [createElement(Button, {
                                        ComponentState: "enabled",
                                        Label: t("general.display"),
                                        OnClick: () => {
                                            props.Dispatch(new Msg(14, []));
                                        },
                                        TestId: "report-view-display-button",
                                        Variant: "primary",
                                    })], ["children", reactApi.Children.toArray(Array.from(elems_14))])]))));
                                }));
                            }));
                        }));
                    }));
                }));
            }
            else {
                return singleton_1(defaultOf());
            }
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_15))])])));
}

export function View(props) {
    let elems_1, elems;
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(init_1, update_1, (_arg, _arg_1) => {
    }), props.Customer, undefined);
    const state_1 = patternInput[0];
    const dispatch = patternInput[1];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["h-full"])], (elems_1 = [createElement(SectionContainer, {
        Content: createElement(ReportControl, {
            Dispatch: dispatch,
            State: state_1,
        }),
    }), reactElement("div", createObj(ofArray([["className", join(" ", ["h-full"])], (elems = [createElement(ReportResultContent, {
        Configuration: props.Configuration,
        Dispatch: dispatch,
        State: state_1,
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

export function ViewWithQueryParameter(props) {
    let elems_1, elems;
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram((tupledArg) => initWithQueryParameter(tupledArg[0], tupledArg[1]), update_1, (_arg, _arg_1) => {
    }), [props.Customer, props.Parameter], undefined);
    const state_1 = patternInput[0];
    const dispatch = patternInput[1];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["h-full"])], (elems_1 = [createElement(SectionContainer, {
        Content: createElement(ReportControl, {
            Dispatch: dispatch,
            State: state_1,
        }),
    }), reactElement("div", createObj(ofArray([["className", join(" ", ["h-full"])], (elems = [createElement(ReportResultContent, {
        Configuration: props.Configuration,
        Dispatch: dispatch,
        State: state_1,
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

